import React, { useCallback } from "react";
import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  setCustomBreakOptions,
  setSelectedStatus,
} from "../../../../app/modules/Auth/_redux/userProfileSlice";
import { UserProfileDropdown } from "./dropdowns/UserProfileDropdown";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../app/util/constants";


export const statusColorCodes = {
  Available: "#1bae96",
  "On Break": "#ffa800",
  "Logged Out": "#b5b5c3",
};


export function QuickUserToggler({ setPsuedoEl }) {
  const { user, custom_breaks_enabled } = useSelector(
    (state) => state.auth,
    shallowEqual
  );

  const dispatch = useDispatch();
  const { initial_status } = useSelector((state) => state.auth);
  const { selectedStatus, customBreakOptions } = useSelector(
    (state) => state.userProfileSlice
  );

  useEffect(() => {
    if (initial_status && Object.keys(selectedStatus).length === 0)
      dispatch(
        setSelectedStatus({
          value: initial_status,
          label: initial_status,
        })
      );
  }, [initial_status, selectedStatus]);

  useEffect(() => {
    getCustomBreakOptions();
  }, [custom_breaks_enabled]);

  customBreakOptions.forEach((ele) => {
    statusColorCodes[ele.value] = "#ffa800";
  });


  customBreakOptions.forEach((breakType) => {
    statusColorCodes[breakType.value] = "#ffa800";
  });


  const getCustomBreakOptions = useCallback(() => {
    if (custom_breaks_enabled) {
      async function fetchCustomBreaks() {
        const params = {
          user_id: user.user_id,
        };
        const response = await axios.get(API_ENDPOINTS.getCustomBreaks, {
          params,
        });
        let breaks = response?.data?.data;
        const formatBreakOptions = [];
        if (breaks) {
          breaks.map((breakType) => {
            formatBreakOptions.push({ label: breakType, value: breakType });
          });
        }
        dispatch(setCustomBreakOptions(formatBreakOptions));
      }
      fetchCustomBreaks();
    }
  }, [custom_breaks_enabled]);

  return <>{<UserProfileDropdown setPsuedoEl={setPsuedoEl} />}</>;
}
